export const FORM_DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  company: '',
};
